import React from "react";
import Header from "./1-header";
import styled from "@emotion/styled";
import Background from '../assets/header-background.png';
import HeaderEnd from "./header-end";
import About from "./2-about";
import Features from "./3-features";
import RoadMap from "./4-roadmap";
import Partner from "./5-partners";
import FAQ from "./6-faq";
import End from "./7-end";
import Revenue from "./8-revenue-sharing";
import Tokenomics from "./peachy-tokenomics";

const BackgroundDiv = styled.div`
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    min-height: 113vh;
    @media (max-width: 599px){
        min-height: 100vh;
    }
    @media (min-width: 1800px){
        min-height: 80vh;
    }
    @media (min-width: 800px) and (max-width: 900px){
        min-height: 125vh;
    }
    @media (min-width: 600px) and (max-width: 800px){
        min-height: 100vh;
    }
`
const Main = () => {
    return (
        <div style={{ backgroundColor: 'black' }}>
            <BackgroundDiv>
                <Header />
            </BackgroundDiv>
            <HeaderEnd/>
            <About /> 
            <Features />
            <RoadMap />
            <Revenue />
            <Partner />
            <Tokenomics/>
            {/* <FAQ /> */}
            <End />
        </div>
    );
}

export default Main;
